import { InvoiceLine, StructureTypeDescriptions } from '@apply/api/src/api/PaymentApi';
import { Fragment } from 'react/jsx-runtime';

interface UnderwritingRowParameters {
    index: number;
    invoiceLine: InvoiceLine;
}

export const UnderwritingRow: React.FC<UnderwritingRowParameters> = ({ index, invoiceLine }) => {
    return (
        <Fragment key={index}>
            <div className='invoice-type'>
                ({invoiceLine.index}) {invoiceLine.address1}
                {invoiceLine.address2?.length ? `, ${invoiceLine.address2}` : ''}{' '}
                {StructureTypeDescriptions[invoiceLine.structureType]}
            </div>
            <div className='invoice-cost' />
            <div className='invoice-subtotal'>${Number(invoiceLine.underwritingFee)}</div>
            <div className='invoice-notes'>{invoiceLine.underwritingFee == 0 ? '(pay at closing)' : ''}</div>
        </Fragment>
    );
};
